<template>
  <div class="filter-line">
    <up-input
      :propValue="value"
      @onInput="(e) => value = e"
    />
    <button
      type="button"
      @click="clickButton"
      class="up-btn-line-icon"
    >
      <i class="exu-search-1" />
    </button>
  </div>
</template>
<script>
export default {
  name: 'upInputFilter',
  props: {
    // начальный запрос: нужен, когда список возвращается к прежнему состоянию
    startValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      localValue: this.startValue,
    };
  },
  watch: {
    // запрос могли сменить снаружи — например, из панели фильтров
    startValue(value) {
      this.localValue = value;
    },
  },
  computed: {
    value: {
      get() {
        return this.localValue;
      },
      set(data) {
        this.localValue = data;
        // this.$emit('onInput', data);
      },
    },
  },
  methods: {
    clickButton() {
      this.$emit('onSearch', this.localValue);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/style/variables.scss';

.filter-line {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding: 0;
  background: #F6F6FA;

  input.up-form-control {
    flex: 1 1 100%;
  }
}
// Квадратная кнопка-иконка в строке поиска: лупа и воронка каталога должны
// выглядеть и нажиматься одинаково, поэтому стиль один на обе.
.up-btn-line-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  padding: 0;
  background: $color-base;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  color: $color-text;

  & > i {
    font-size: 1.25rem;
  }

  &:active {
    background-color: $color-accent;
    border-color: $color-accent;
    color: $color-base;
  }

  // фильтр применён — воронка залита акцентом
  &.is-applied {
    background-color: $color-accent;
    border-color: $color-accent;
    color: $color-base;
  }
}
</style>
